/*
 * This file contains all ids and classes you can find in the data-explorer
 *
 * classes and ids are define like following
 *
 *  - ID_[NAME] are uniq in the all application
 *  - CLASS_[NAME] those classes are commons for all application
 *
 * They are the stable anchors for custom stylesheets: target them rather than
 * tag names, data-testid attributes or generated classes (jss*, makeStyles-*),
 * which change between releases. Target a state with an aria attribute, e.g.
 * the open home facet: #id_home_facets button[aria-expanded="true"]
 *
 */

export const CLASS_PAGE = 'class_page';

// HOME PAGE
export const ID_HOME_PAGE = 'id_home_page';
export const ID_HOME_SPOTLIGHT = 'id_home_spotlight';
export const ID_HOME_FACETS = 'id_home_facets';

// ERROR PAGE
export const ID_ERROR_PAGE = 'id_error_page';

// SEARCH PAGE
export const ID_SEARCH_PAGE = 'id_search_page';

// VIS PAGE
export const ID_VIS_PAGE = 'id_vis_page';

// VIEWER COMPONENT
export const ID_VIEWER_COMPONENT = 'id_viewer_component';

// OVERVIEW COMPONENT
export const ID_OVERVIEW_COMPONENT = 'id_overview_component';

// APPBAR
export const ID_APPBAR = 'id_appbar';

// HEADER (top bar and appbar)
export const ID_HEADER = 'id_header';

// TOP BAR (logo, header message, languages)
export const ID_TOPBAR = 'id_topbar';

// FOOTER
export const ID_FOOTER = 'id_footer';
